<!-- eslint-disable max-len -->
<route>
    {
      "meta": {
        "requireAdmin": true,
        "customSite": true
      }
    }
    </route>
<template>
  <div class="py-1">
    <!-- -------------------------------------------header tab section--------------------------  -->
    <div class="absolute top-right flex">
      <TabButtons
        label="overview"
        :callback="(e) => handlePageChange(e)"
        :currentValue="currentComponent"
      />
      <div v-if="userDetails && userDetails.role !== 'USER'">
        <TabButtons
          label="activity"
          :callback="(e) => handlePageChange(e)"
          :currentValue="currentComponent"
        />
      </div>
    </div>
    <!-- ---------------------------------------------------overview ------------------------------------->
    <section v-if="currentComponent == 'overview'">
      <Overview />
    </section>
    <!-- ---------------------------------------------------activity ------------------------------------->
    <section v-if="currentComponent == 'activity'">
      <UserActivity />
    </section>
  </div>
</template>
<script>
import store from '@/store';
import TabButtons from '@/components/Audience/TabButtons.vue';
import Overview from '@/components/Audience/Overview.vue';
import UserActivity from '../user-activity.vue';

export default {
  name: 'audience',
  layout: 'admin',
  store,
  data() {
    return {
      userInfo: null,
      currentComponent: 'overview',
      courseId: '',
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    userDetails() {
      console.log(this.$store.state?.userDetails);
      return this.$store.state?.userDetails;
    },
  },
  mounted() {
    if (!this.userDetails) {
      this.$store.dispatch('getMyDetails', {});
    }
  },
  methods: {
    handlePageChange(e) {
      this.currentComponent = e;
    },
  },
  components: { TabButtons, Overview, UserActivity },
};
</script>

<style>
.top-right {
  top: 1.5rem;
  right: 4rem;
}
.reaction:hover {
  @apply cursor-pointer;
}
.audience_header {
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 0.1rem;
}
</style>
